export const defaultTypographyHeadingStyles = {
    className: "ignore-global-styles",
    gutterBottom: true,
};
